import { RefillsMedicationOrderPage } from '@pages/Refills/Medication/Order';
import { SuspenseLoader } from '@router/components';
import { REFILLS_ROUTE_PATHNAME } from '../routePathnames';
import refillsLoader from './refillsLoader';
import { REFILLS_ROUTE_ID } from 'constants/routeIds';

export const refillsRoutes = [
  {
    id: REFILLS_ROUTE_ID,
    handle: {
      position: 1,
    },
    path: REFILLS_ROUTE_PATHNAME,
    loader: refillsLoader,
    element: (
      <SuspenseLoader>
        <RefillsMedicationOrderPage />
      </SuspenseLoader>
    ),
  },
];
